//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/FileNew.js";
import "../no/Section.js";
let d=[[[0,"Filename",1,0],[1,"FittingMembers",0,"Routing.RouteObjectCollector",0],[0,"FlangeDirection",1,0],[1,"FlangeOffset",0,"Expression",0],[0,"FlangeSketch",0,"Section",0],[1,"FlangeThickness",0,"Expression",0]],[[["fileNewBuilder"],"SetFilenameFromFilenewbuilder",{},1,0],[[],"GetRequiredAttributes",{R_:{charx_data:"Routing.CharacteristicList"}},0,0],[["charx_data"],"SetRequiredAttributes",{},1,0],[[],"GetOptionalAttributes",{R_:{charx_data:"Routing.CharacteristicList"}},0,0],[["charx_data"],"SetOptionalAttributes",{},1,0]],[]];
SPLM.Routing.WatertightFittingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.WatertightFittingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;